import RequestBase from './RequestBase';

export default class ConnectRequest extends RequestBase {
    constructor(username, password) {
        super();
        this._url = '/connect/token';
        this.method = 'POST';
        this.contentType = 'application/x-www-form-urlencoded';
        this.parameters = [
            'client_id',
            'client_secret',
            'grant_type',
            'username',
            'password'
        ];
        this.apiId = undefined;
        this.apiKey = undefined;
        this.username = username;
        this.password = password;
    }

    get body() {
        return 'client_id=' + this.apiId +
               '&client_secret=' + this.apiKey +
               '&grant_type=password&username=' + this.username +
               '&password=' + this.password;
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Connections.js